const urls = [
    'https://api.bigbays.cn/'
];
const defaultUrl = urls[0];
export default defaultUrl;


// WEBPACK FOOTER //
// ./src/ws/urls.js